import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import {
    RING_CENTER,
    RING_CIRCUMFERENCE,
    RING_MAX_PERCENT,
    RING_RADIUS,
    RING_STROKE_WIDTH,
    RING_VIEWBOX,
    TEST_ID
} from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const RingGauge: FunctionComponent<Props> = ({
    className = '',
    label,
    notConfiguredText,
    serviceLife,
    size = 'small',
    testId = TEST_ID
}) => {
    const svgClass = size === 'large' ? styles.ringSvgLarge : styles.ringSvg;
    const remaining = serviceLife.configured
        ? Math.min(serviceLife.remaining, RING_MAX_PERCENT)
        : 0;
    const dash = (RING_CIRCUMFERENCE * remaining) / RING_MAX_PERCENT;
    const fillStateClass = serviceLife.configured ? styles.fillRemaining : styles.fillEmpty;
    const remainingStyle = { ['--ring-remaining' as string]: `${remaining}%` };
    const valueText = serviceLife.configured
        ? `${Math.round(serviceLife.remaining)}%`
        : notConfiguredText;

    return (
        <VerticalContainer className={`${styles.ringCell} ${className}`} testId={testId}>
            <svg aria-hidden='true' className={svgClass} viewBox={RING_VIEWBOX}>
                <circle
                    className={styles.ringTrack}
                    cx={RING_CENTER}
                    cy={RING_CENTER}
                    fill='none'
                    r={RING_RADIUS}
                    strokeWidth={RING_STROKE_WIDTH}
                />

                <circle
                    className={`${styles.ringFill} ${fillStateClass}`}
                    cx={RING_CENTER}
                    cy={RING_CENTER}
                    fill='none'
                    r={RING_RADIUS}
                    strokeDasharray={`${dash} ${RING_CIRCUMFERENCE - dash}`}
                    strokeDashoffset={RING_CIRCUMFERENCE / 4}
                    strokeLinecap='round'
                    strokeWidth={RING_STROKE_WIDTH}
                    style={remainingStyle}
                />
            </svg>

            <Wrapper className={styles.ringLabel}>{label}</Wrapper>

            <Wrapper className={styles.ringValue}>{valueText}</Wrapper>
        </VerticalContainer>
    );
};

export default RingGauge;
